export const environment = {
  production: false,
  serviceWorker: true,
  apiLocations: {
    cookieDomain: '.amatis.dev',
    cookieName: 'AmatisTeleHealth-dev',
    identity: '/identity/api/v1',
    patient: '/patient/api/v1',
    patientHub: '/patient-hub',
    customer: '/customer/api/v1',
    chat: '/chat/api/v1',
    notification: '/notification/api/v1',
    backOffice: 'https://backoffice.amatis.dev',
    invoice: '/invoice/api/v1',
  },
};
